import {
  getFilters,
  updateFilters,
  facetToRender,
  getSeriesFilterString,
  getcategoryFilter,
  getFilterParse,
} from "./filters";
import { fetchRetailRecommendations, getVisitorId } from "./g-utils";

if (performance.navigation.type != performance.navigation.TYPE_RELOAD) {
  const paramsQuery = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

  let queryString = "";
  if (paramsQuery) {
    queryString = paramsQuery.q;
  }

  resetOldFilters();
  const firstEntryFilters = {
    filterCheckedItems: [],
    queryString: [],
    filterPrice: {},
  };

  if (!queryString?.includes("opusID") && queryString) {
    firstEntryFilters.filterCheckedItems.push("filter.p.availability-IN_STOCK");
    firstEntryFilters.queryString.push('(availability: ANY("IN_STOCK"))');
  }

  sessionStorage.setItem("defaultFilters", JSON.stringify(firstEntryFilters));
}

let skeletonProducts;
const changeLayoutBtns = document.querySelectorAll('[data-action="change-layout"]')

document.addEventListener("search:page", (e) => {
  window.visitorId = window.getCookie('_shopify_y')
  let newLayoutMode;
  const layoutMode = sessionStorage.getItem("newLayoutMode");
  const searchProductList = document.querySelector("[data-search-product-list]")

  if (layoutMode) {
    newLayoutMode = layoutMode;
  } else {
    newLayoutMode = "list";
  }

  searchProductList.classList.remove("js-list", "js-grid");
  searchProductList.classList.add(`js-${newLayoutMode}`);

  const skeletonProductsList = document.querySelector("[data-skeleton-products-list]");
  const skeletonProductsVertical = document.querySelector("[data-skeleton-products-vertical]");
  changeLayoutBtns.forEach(btn => btn.setAttribute('aria-disabled', true));
  if (newLayoutMode == "list") {
    skeletonProducts = skeletonProductsList;
    skeletonProductsList.classList.remove("jc-hidden");
    skeletonProductsVertical.classList.add("jc-hidden");
  } else {
    skeletonProducts = skeletonProductsVertical;
    skeletonProductsVertical.classList.remove("jc-hidden");
    skeletonProductsList.classList.add("jc-hidden");
  }


  searchProductList.classList.add("jc-hidden");

  _loadSearchPage(e.detail);
});

document.addEventListener("search:pageUpdateLayoutMode", (e) => {
  sessionStorage.setItem("newLayoutMode", `${e.detail.layoutMode}`);
});

document.addEventListener("search:pageUpdateSorting", (e) => {
  sessionStorage.setItem("sortPageMode", `${e.detail.sortValue}`);
  sessionStorage.setItem("currentPage", "");
});

document.addEventListener("search:pageUpdateProductsPerPage", (e) => {
  sessionStorage.setItem("productsPerPage", `${e.detail.productsPerPage}`);
  sessionStorage.setItem("currentPage", "");
});

document.addEventListener("search:pageUpdatePagination", (e) => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
  sessionStorage.setItem("currentPage", e.detail.target.dataset.page);
});



export let options = {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: "",
};

const facetsPreset = [
  { facetKey: { key: "brands", returnMinMax: true }, limit: 300 },
  {
    facetKey: {
      key: "price",
      returnMinMax: true,
      intervals: [{ minimum: 0, maximum: 99999999999999 }],
    },
  },
  { facetKey: { key: "attributes.series" }, limit: 300 },
  { facetKey: { key: "categories" }, limit: 300 },
  { facetKey: { key: "attributes.format" }, limit: 300 },
  { facetKey: { key: "attributes.language" }, limit: 300 },
  { facetKey: { key: "attributes.publisher" }, limit: 300 },
  { facetKey: { key: "availability" } },
];


// set layout for product displaing on search page
function getNewLayoutMode(event) {
  let newLayoutMode;

  if (sessionStorage.getItem("newLayoutMode")) {
    newLayoutMode = sessionStorage.getItem("newLayoutMode");
  } else {
    newLayoutMode = event.options.defaultLayout;
    sessionStorage.setItem("newLayoutMode", newLayoutMode);
  }

  return newLayoutMode;
}



// get number of products per page
function getDefaultProductsPerPage(query, event) {
  let defaultProductsPerPage;

  if (sessionStorage.getItem("productsPerPage")) {
    defaultProductsPerPage = sessionStorage.getItem("productsPerPage");
  } else {
    defaultProductsPerPage = event.options.defaultProductsPerPage;
    sessionStorage.setItem("productsPerPage", defaultProductsPerPage);
  }

  query.branchCountResultsSearch = defaultProductsPerPage;

  return defaultProductsPerPage;
}

// get current page from general search
function getCurrentPage(query, defaultProductsPerPage) {
  let currentPage;

  if (sessionStorage.getItem("currentPage")) {
    currentPage = sessionStorage.getItem("currentPage");
  } else {
    currentPage = 1;
    sessionStorage.setItem("currentPage", currentPage);
  }

  if (currentPage > 1) {
    query.offsetSearch = (currentPage - 1) * defaultProductsPerPage;
  }

  return currentPage;
}

// define type of sorting on the search page
function getSortPageMode(event, query) {
  let sortPageMode;

  if (sessionStorage.getItem("sortPageMode")) {
    sortPageMode = sessionStorage.getItem("sortPageMode");
  } else {
    sortPageMode = event.options.currentSortBy
      ? event.options.currentSortBy
      : "relevance";
    sessionStorage.setItem("sortPageMode", `${sortPageMode}`);
  }

  if (sortPageMode == "price-ascending") {
    query.searchOrderBy = "price asc";
  } else if (sortPageMode == "price-descending") {
    query.searchOrderBy = "price desc";
  }

  return sortPageMode;
}

// reset applyed filters
function resetOldFilters() {
  document.dispatchEvent(
    new CustomEvent("search:resetsessionStorageVariablesFilters")
  );
}

async function getSearchResult(
  event,
  filterParse,
  defaultProductsPerPage,
  currentPage,
  sortPageMode,
  url,
  query,
  paramsQuerySearchText,
  searchSectionId,
  newLayoutMode,
  paramsQuery,
  categoryFilter,
  seriesFilterString,
  data,
  trackAuthorView
) {

 
  let searchProductVariants = [];
  const productDetails = []

  const productsResults = data.results;
  const attributionToken = data.attributionToken;
  const resultsProductsCount = data.totalSize || 0;
  if (productsResults) {
    // find variant
    productsResults.forEach((searchProduct) => {
      if (searchProduct.product.title) {
        searchProductVariants.push(searchProduct.product);
        productDetails.push({
          product: {
            id: `${searchProduct.id}`,
          },
        });
      }
    });

    sessionStorage.setItem("attributionToken", `${attributionToken}`);

    window.dataLayer.push({
      cloud_retail: "",
    });

    const filterActivePriceMin = filterParse?.filterPrice?.min;
    const filterActivePriceMax = filterParse?.filterPrice?.max;

    const countPagination = Math.ceil(
      resultsProductsCount / +defaultProductsPerPage
    );

    let pagination = document.querySelector("pagination-search");

    if (!pagination) {
      pagination = document.createElement("pagination-search");
      pagination.setAttribute("page", currentPage);
      document.querySelector("[data-pagination]").appendChild(pagination);
    }

    pagination.updatePagination(
      data.totalSize,
      parseInt(currentPage),
      defaultProductsPerPage
    );

    const promotionalCardsByIndex = {};
    document.querySelectorAll('[data-search-promotion-card-position]')
      .forEach(card => {
        promotionalCardsByIndex[card.dataset.searchPromotionCardPosition] = card
      });

    const trackAuthorViewList = []

    const productTemplateItems = searchProductVariants
      .map((product, index) => {
        let cardTemplate = promotionalCardsByIndex[index + 1]?.innerHTML || '';
        return cardTemplate + getTemplateProductResultItem(
          product,
          newLayoutMode,
          event,
          trackAuthorViewList,
          trackAuthorView
        );
      })
      .join("");

    if (trackAuthorView) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'view_author_ta',
        ecommerce: {
          items: trackAuthorViewList
        }
      });
    }

    const headingEl = event.element.querySelector('.js-heading')
    const booksCountEl = headingEl?.querySelector('.js-books-count');
    if (booksCountEl) {
      booksCountEl.innerHTML = data.totalSize;
      headingEl.setAttribute('aria-busy', false);
    }
    event.element.querySelector("[data-search-product-list]").innerHTML =
      productTemplateItems;
    event.element
      .querySelector("[data-search-product-list]")
      .classList.remove("jc-hidden");
    skeletonProducts.classList.add("jc-hidden");

    event.element.querySelector(
      "[data-dsk-results-count]"
    ).innerHTML = `Affiche ${currentPage == 1
      ? currentPage
      : (currentPage - 1) * defaultProductsPerPage + 1
    } - 
        ${currentPage == countPagination
        ? resultsProductsCount
        : currentPage * defaultProductsPerPage
      } 
        de ${resultsProductsCount} résultats`;

    if (event.element.querySelector("[data-mob-results-count]")) {
      event.element.querySelector(
        "[data-mob-results-count]"
      ).innerHTML = `${resultsProductsCount} résultats`;
    }
    event.element.querySelector(
      "[data-page-size]"
    ).innerHTML = `${defaultProductsPerPage} par page`;
    event.element.querySelector(`[data-sort]`).innerHTML =
      event.element.querySelector(
        `[data-value^="${sortPageMode}"]`
      ).textContent;
    event.element.querySelectorAll(`[data-value]`).forEach((element) => {
      element.classList.remove("is-selected");
    });
    event.element
      .querySelector(`[data-value^="${sortPageMode}"]`)
      .classList.add("is-selected");
    event.element
      .querySelector(`[data-value^="${defaultProductsPerPage}"]`)
      .classList.add("is-selected");
    let countFilters = 0;

    const customeElActiveFilters =
      event.element.querySelector("active-filters");
    if (filterParse?.queryString.length > 0) {
      const activeFilters = filterParse.filterCheckedItems;

      activeFilters.forEach((activeFilter) => {
        if (activeFilter.includes("availability")) {
          return;
        }

        let checkActiveFilter = "";
        if (activeFilter.indexOf('"') > -1) {
          checkActiveFilter = customeElActiveFilters.querySelector(
            `active-filter-item label[for='` + activeFilter + `']`
          );
        } else if (activeFilter.indexOf("'") > -1) {
          checkActiveFilter = customeElActiveFilters.querySelector(
            `active-filter-item label[for="` + activeFilter + `"]`
          );
        } else {
          checkActiveFilter = customeElActiveFilters.querySelector(
            `active-filter-item label[for='` + activeFilter + `']`
          );
        }

        if (!checkActiveFilter) {
          const activeFilterItem = document.createElement("active-filter-item");
          activeFilterItem.activeFilter({ type: "filter", activeFilter });
          customeElActiveFilters.appendChild(activeFilterItem);
        }
      });

      Array.from(
        customeElActiveFilters.querySelectorAll(`active-filter-item label`)
      ).forEach((el) => {
        if (!activeFilters.includes(el.getAttribute("for"))) {
          el.closest("active-filter-item").remove();
        }
      });

      if (filterActivePriceMin && filterActivePriceMax) {
        const activeFilterItemPrice =
          document.createElement("active-filter-item");
        activeFilterItemPrice.setAttribute("data-action", "clear-filter-price");
        activeFilterItemPrice.activeFilter({
          type: "price",
          activeFilter: `${filterActivePriceMin} € - ${filterActivePriceMax} €`,
        });
        customeElActiveFilters.appendChild(activeFilterItemPrice);
      }

      if (categoryFilter?.categoryFilterActive.length > 0) {
        categoryFilter?.categoryFilterActive?.forEach((categoryActiveName) => {
          const activeFilterItemCategory =
            document.createElement("active-filter-item");
          activeFilterItemCategory.setAttribute(
            "data-action",
            "clear-filter-category"
          );
          activeFilterItemCategory.activeFilter({
            type: "category",
            activeFilter: categoryActiveName,
          });
          customeElActiveFilters.appendChild(activeFilterItemCategory);
          countFilters += 1;
        });
      }

      if (seriesFilterString?.filterCheckedItems.length > 0) {
        seriesFilterString?.filterCheckedItems?.forEach((seriesActiveName) => {
          const activeFilterItemSeries =
            document.createElement("active-filter-item");
          activeFilterItemSeries.setAttribute(
            "data-action",
            "clear-filter-series"
          );
          activeFilterItemSeries.activeFilter({
            type: "series",
            activeFilter: seriesActiveName,
          });
          customeElActiveFilters.appendChild(activeFilterItemSeries);
        });
      }

      if (filterParse.filterCheckedItems.length > 0) {
        countFilters += filterParse.filterCheckedItems.includes(
          "filter.p.availability-IN_STOCK"
        )
          ? filterParse.filterCheckedItems.length - 1
          : filterParse.filterCheckedItems.length;
      }

      if (filterParse.filterPrice.min && filterParse.filterPrice.max) {
        countFilters += 1;
        const priceRange = event.element.querySelectorAll("price-range");
        priceRange.forEach((range) => {
          range.querySelector(".price-range__range-group").style.cssText = `
            --range-min:${(filterActivePriceMin / range.querySelector(".range-min").max) *
            100
            }%;
            --range-max:${(filterActivePriceMax / range.querySelector(".range-min").max) *
            100
            }%;`;
          range.querySelector(".range-min").value = filterActivePriceMin;
          range.querySelector(".range-max").value = filterActivePriceMax;
          range.querySelector("[name='filter.v.price.gte']").value =
            filterActivePriceMin;
          range.querySelector("[name='filter.v.price.lte']").value =
            filterActivePriceMax;
        });
      }

      if (countFilters > 0) {
        event.element
          .querySelector(".collection__filter-icon")
          ?.classList.add("collection__filter-icon--active");
        event.element.querySelector(
          "[data-mobile-filter-count]"
        ).innerHTML = `&nbsp;(${countFilters})`;
      }
    } else {
      customeElActiveFilters
        .querySelectorAll("active-filter-item")
        .forEach((el) => {
          el.remove();
        });
      event.element.querySelector("[data-mobile-filter-count]").innerHTML = "";
      event.element
        .querySelector(".collection__filter-icon")
        ?.classList.remove("collection__filter-icon--active");
    }
    event.element
      .querySelector(`.search-result`)
      .classList.remove("jc-hidden");
    event.element
      .querySelector(`.empty-search-result`)
      .classList.add("jc-hidden");
  }

  const ga_search = {
    event: "ga_search",
    cloud_retail: {
      eventType: "search",
      visitorId: `${getVisitorId()}`,
      orderBy: `${query?.searchOrderBy ?? ""}`,
      offset: +query?.offsetSearch || 0,
      searchQuery: `${paramsQuerySearchText}`,
      filter: `${filterParse?.queryString.join(" AND ") ?? ""}`,
      productDetails: null,
      attributionToken: null,
      userInfo: {
        userId: `${window.userId}`,
      },
      result_count: resultsProductsCount,
    },
  };

  if(attributionToken) {
    ga_search.attributionToken = `${attributionToken}`;
  }

  console.log(ga_search);

  window.dataLayer.push(ga_search);
}

// apply clicked autocomplete filter from header search input to the search page
function setAutocompleteFilter(paramsQuery, redirectKey) {
  const paramsQuerySearchText = paramsQuery.q;
  const findCurrentAutocompleteType = facetToRender.find(
    (facet) => facet.autocomplete_key == redirectKey
  );

  if (redirectKey === "category") {
    const categoryFilter = {
      categoryFilterString: "",
      categoryFilterActive: [],
    };

    categoryFilter.categoryFilterString = `categories: ANY("${paramsQuerySearchText}")`;
    categoryFilter.categoryFilterActive.push(paramsQuerySearchText);

    sessionStorage.setItem("categoryFilter", JSON.stringify(categoryFilter));
  } else if (redirectKey === "series") {
    const sagaFilterString = `(attributes.series: ANY("${paramsQuerySearchText}"))`;
    const seriesObj = {
      queryString: "",
      filterCheckedItems: [],
    };
    seriesObj.queryString = sagaFilterString;
    seriesObj.filterCheckedItems.push(paramsQuerySearchText);

    sessionStorage.setItem("seriesFilterString", JSON.stringify(seriesObj));
  } else if (findCurrentAutocompleteType) {
    const filterParse = {
      filterCheckedItems: [],
      queryString: [],
      filterPrice: {},
    };

    filterParse.filterCheckedItems.push(
      `filter.p.${findCurrentAutocompleteType.facet_key}-${paramsQuerySearchText}`
    );
    filterParse.filterCheckedItems.push("filter.p.availability-IN_STOCK");
    filterParse.queryString.push(
      `(${findCurrentAutocompleteType.facet_key}: ANY("${paramsQuerySearchText}"))`
    );
    filterParse.queryString.push('(availability: ANY("IN_STOCK"))');

    sessionStorage.setItem("defaultFilters", JSON.stringify(filterParse));
  }

  sessionStorage.removeItem("redirectKey");
}

async function _loadSearchPage(detail) {
  const event = detail.event;
  const searchSectionId = event.element.dataset.sectionId;
  const redirectKey = sessionStorage.getItem("redirectKey") || null;
  let trackAuthorView = false
  const urlParams = new URLSearchParams(document.location.search);
  if (urlParams.get("author-page") === "true") {
    trackAuthorView = true
  }
  const newLayoutMode = getNewLayoutMode(event);
  const paramsQuery = window.location.href.includes("favourite_product")
    ? { q: event.element.dataset.favouriteProductIds }
    : new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

  const paramsQuerySearchText = window.location.href.includes(
    "favourite_product"
  )
    ? event.element.dataset.favouriteProductIds
    : paramsQuery.q.includes("opusID")
      ? paramsQuery.q.split(":")[1]
      : paramsQuery.q;
  // store query parameters from URL

  setAutocompleteFilter(paramsQuery, redirectKey);

  const seriesFilterString = getSeriesFilterString();
  const categoryFilter = getcategoryFilter();
  const query = {
    query: paramsQuerySearchText,
    rout: "search",
    visitorId: getVisitorId(),
    branchSearch: "0",
    userId: window.userId
  };
  const filterParse = getFilterParse(
    query,
    categoryFilter,
    seriesFilterString,
    paramsQuery
  );

  const defaultProductsPerPage = getDefaultProductsPerPage(query, event);
  const currentPage = getCurrentPage(query, defaultProductsPerPage);
  const sortPageMode = getSortPageMode(event, query);

  const url = window.Shopify.routes.root + "apps/search";
  query.facetKeysSearch = facetsPreset;
  options.body = JSON.stringify(query);

  try {
    const response = await fetch(url, options);
    let data = response;
    if (data.ok) {
      data = await data.json();
    } else {
      data = await data.text();
    }

    if (!document.querySelector("#filter-p-availability")) {
      const activeFiltersItems = filterParse?.filterCheckedItems ?? [];

      for (const facet in facetToRender) {
        // Create a new instance of ProductItem
        if (facetToRender[facet].facet_key == "availability") {
          const filterBlock = document.createElement("filter-block");
          filterBlock.setParentBlockFilterText = {
            title: facetToRender[facet].facet_title,
            type: facetToRender[facet].facet_key,
            showSearch: facetToRender[facet].show_search,
          };

          //render availability

          filterBlock.setChildItemFilterAvailability = {
            title: facetToRender[facet].facet_title,
            data: [{ value: "IN_STOCK" }],
            type: facetToRender[facet].facet_key,
            checkedItems: activeFiltersItems,
          };

          filterBlock.setAttribute("id", facetToRender[facet].facet_key);

          // Append the new product item to the container
          document.querySelector("active-filters").after(filterBlock);
        }
      }
    }

    if (data.results) {
      await getFilters(
        event,
        url,
        filterParse,
        paramsQuery,
        paramsQuerySearchText,
        data
      );

      getSearchResult(
        event,
        filterParse,
        defaultProductsPerPage,
        currentPage,
        sortPageMode,
        url,
        query,
        paramsQuerySearchText,
        searchSectionId,
        newLayoutMode,
        paramsQuery,
        categoryFilter,
        seriesFilterString,
        data,
        trackAuthorView
      );

      updateFilters(url, filterParse, query, data);
    } else {
      fetchData(url, options, event, paramsQuery, filterParse, query);
      const ga_search = {
        event: "ga_search",
        cloud_retail: {
          eventType: "search",
          visitorId: `${getVisitorId()}`,
          orderBy: `${query?.searchOrderBy ?? ""}`,
          offset: +query?.offsetSearch || 0,
          searchQuery: `${paramsQuerySearchText}`,
          filter: `${filterParse?.queryString.join(" AND ") ?? ""}`,
          productDetails: null,
          attributionToken: null,
          userInfo: {
            userId: `${window.userId}`,
          },
          result_count: 0,
        },
      };
      window.dataLayer.push(ga_search);
    }
  } catch (error) {
    console.error(error);
    event.element
      .querySelector(`.search-result`)
      .classList.add("jc-hidden");
    event.element
      .querySelector(`.jc-main-search-container .layout__section--secondary`)
      .classList.add("jc-hidden");
    event.element
      .querySelector(`.empty-search-result`)
      .classList.remove("jc-hidden");
    event.element.querySelector(
      `.empty-search-result .empty-state__description span`
    ).innerHTML = paramsQuery.q.trim();
  }

  changeLayoutBtns.forEach(btn => btn.setAttribute('aria-disabled', false));

  if (
    !document
      .querySelector("[data-skeleton-filters]")
      .classList.contains("jc-hidden")
  ) {
    document
      .querySelector("[data-skeleton-filters]")
      .classList.add("jc-hidden");
  }
}

// Main function to fetch data and handle the result
async function fetchData(url, options, event, paramsQuery, filterParse, query) {
  try {
    // Filter out 'IN_STOCK' items from queryString
    filterParse.queryString = filterParse.queryString.filter(
      (item) => !item.includes("IN_STOCK")
    );
    query.filterSearch = filterParse.queryString.join(" AND ");
    options.body = JSON.stringify(query);

    // Fetch data from server
    const response = await fetch(url, options);
    const data = response.ok ? await response.json() : await response.text();

    // Handle search results in the DOM
    handleSearchResult(event, data, paramsQuery);

    // If results exist, fetch recommendations
    if (data.results) {
      await fetchRecommendations(data.results[0].id, event);
    } else {
      await processRecommendations({ result: [] }, event);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    handleEmptySearchResult(event, paramsQuery.q.trim());
  }
}

// Handle updating the DOM based on the search results
function handleSearchResult(event, data, paramsQuery) {
  const {
    cardElement,
    secondarySection,
    inStockEmptyResult,
    emptyResult,
    recommendation,
  } = getDomElements(event);

  document.querySelector('[data-section-type="collection"]').style.backgroundColor = '#FCFCFD'

  // Update DOM elements based on whether there are results
  if (data.results) {
    hideElements([cardElement, secondarySection]);
    showElement(inStockEmptyResult);
    showElement(recommendation);
    inStockEmptyResult.querySelector(
      ".empty-state__description span"
    ).textContent = paramsQuery.q.trim();
  } else {
    hideElements([cardElement, secondarySection]);
    showElement(emptyResult);
    showElement(recommendation);
    emptyResult.querySelector(".empty-state__description span").textContent =
      paramsQuery.q.trim();
  }
}

// Handle when no search results are found (Error case)
function handleEmptySearchResult(event, queryText) {
  const { cardElement, secondarySection, emptyResult } = getDomElements(event);
  hideElements([cardElement, secondarySection]);
  showElement(emptyResult);
  emptyResult.querySelector(".empty-state__description span").textContent =
    queryText;
}

// Function to fetch product recommendations
async function fetchRecommendations(productId, event) {

  try {
    const result = await fetchRetailRecommendations({
      type: "no_stock",
      products: [{ primaryProductId: productId }],
      pageSize: 20,
    })
    // Process recommendations and update the DOM
    await processRecommendations(result, event);
  } catch (error) {
    console.error("Error fetching recommendations:", error);
  }
}

// Helper function to update the DOM with fetched recommendations
async function processRecommendations(result, event) {
  const ajaxRecommendationSection = document.querySelector(
    "[data-recommendation] g-carousel"
  );
  if (!ajaxRecommendationSection) return;

  const sectionId = ajaxRecommendationSection.dataset.sectionId;
  const productHandles = result.result
    .map((product) => product?.isbn)
    .join(",");
  const recommendationUrl = `/search/?sections=${sectionId}${productHandles ? `&product_ids=${productHandles}` : ""
    }`;

  try {
    const response = await fetch(recommendationUrl);
    const res = await response.json();
    const keys = Object.keys(res);

    if (keys.length > 0) {
      const recommendationTemplateText = res[keys[0]];
      const recommendationTemplate = new DOMParser()
        .parseFromString(recommendationTemplateText, "text/html")
        .querySelector("[data-recommendation] .splide__list").innerHTML;

      // event.element.insertAdjacentHTML("beforeend", recommendationTemplate);
      ajaxRecommendationSection.splideList.innerHTML = recommendationTemplate;
      ajaxRecommendationSection.refresh();
    }
  } catch (error) {
    console.error("Error processing recommendations:", error);
  }
}

// Utility functions for common DOM manipulations
function getDomElements(event) {
  return {
    cardElement: event.element.querySelector(
      ".search-result"
    ),
    secondarySection: event.element.querySelector(
      ".jc-main-search-container .layout__section--secondary"
    ),
    inStockEmptyResult: event.element.querySelector(
      ".empty-search-result-in-stock"
    ),
    emptyResult: event.element.querySelector(".empty-search-result"),
    recommendation: document.querySelector("[data-recommendation]"),
  };
}

function hideElements(elements) {
  elements.forEach((element) => element.classList.add("jc-hidden"));
}

function showElement(element) {
  if (element) {
    element.classList.remove("jc-hidden");
  }
}


function formatDate(date) {
  const day = date.getDate();
  const monthIndex = date.getMonth();
  const year = date.getFullYear();

  const months = [
    "Janvier",
    "Février",
    "Mars",
    "Avril",
    "Mai",
    "Juin",
    "Juillet",
    "Août",
    "Septembre",
    "Octobre",
    "Novembre",
    "Décembre",
  ];
  const monthName = months[monthIndex];

  const paddedDay = day.toString().padStart(2, "0");

  return `${paddedDay} ${monthName} ${year}`;
}

const favouriteProductBtnTemplate = document.querySelector("#favourite-product-btn-template").innerHTML;
const productItemTemplate = document.querySelector("#product-item-template").innerHTML;

function getTemplateProductResultItem(product, newLayoutMode, event, trackAuthorViewList, trackAuthorView) {
  const getSortedVariants = (variants) =>
    variants.edges.sort(
      (prev, next) =>
        Number.parseFloat(prev.node.price) - Number.parseFloat(next.node.price)
    );
  
  let firstAvailableVariant = "";
  
  let [L1_main_category, L2_main_category, pricing_group, pricing_stage] = [null, null, null, null];
  if (product.shopifyRespone) {
    const sortedVariants = getSortedVariants(product.shopifyRespone.variants);
    firstAvailableVariant =
      sortedVariants.find((variant) => variant.node.availableForSale)?.node ||
      sortedVariants.find((variant) => !variant.node.availableForSale)?.node ||
      "";
    L1_main_category = product.shopifyRespone.L1_main_category?.value;
    L2_main_category = product.shopifyRespone.L2_main_category?.value;
    pricing_group = product.shopifyRespone.pricing_group?.value;
    pricing_stage = product.shopifyRespone.pricing_stage?.value;
  }

  const collection = product?.shopifyRespone.collections?.edges[0]?.node;
  const collectionId = collection?.id.split('/').pop();

  const productShopifyId = product.attributes.shopifyProductId
    ? +product.attributes.shopifyProductId.text[0].split("/").pop()
    : "";
  const favouriteProducts = window.favouriteProducts || null;

  const checkFavouriteProduct = favouriteProducts?.includes(productShopifyId);
  const productURL = product.uri;
  const imgSrc = product?.images?.[0]?.uri || "";
  let hideImage = imgSrc ? false : true;
  const title = product.title;
  const author = product.attributes?.author?.text[0];
  const price = firstAvailableVariant?.price ?? product.priceInfo.price;
  const compareAtPrice = firstAvailableVariant?.compareAtPrice ?? product.priceInfo.originalPrice;
  const available = firstAvailableVariant?.availableForSale ?? false;
  const mainSearch = event.options?.mainSearch ? true : false;
  const firstAvailableVariantID = firstAvailableVariant?.id.split("/").pop() ?? "";
  const format = product.attributes.format?.text?.[0];
  const publisher = product.attributes.publisher?.text?.[0];
  const publicationDate = product.attributes.publicationDate?.text
    ? new Date(product.attributes.publicationDate?.text)
    : "";
  const publicationDateStr = publicationDate ? formatDate(publicationDate) : "";

  if (trackAuthorView) {
    trackAuthorViewList.push({
      item_id: productShopifyId,
      item_variant: firstAvailableVariant?.title,
      item_variant_id: firstAvailableVariantID,
      item_variant_title: firstAvailableVariant?.title,
      item_product_id: productShopifyId,
      item_product_title: title,
      item_name: title,
      discount: compareAtPrice ? Number((compareAtPrice - price).toFixed(2)) : 0,
      price: +price,
      item_brand: author,
      item_category: "",
      item_list_id: collectionId || null,
      item_list_name: collection?.title || null,
      sku: firstAvailableVariant?.sku
    })
  }

  const favouriteProductEl = favouriteProductBtnTemplate
      .replaceAll("[[productShopifyId]]", productShopifyId)
      .replaceAll("[[favouriteProductBtnClass]]", checkFavouriteProduct ? "jc-fill-electricViolet jc-text-electricViolet" : "")
      .replaceAll("[[item_id]]", firstAvailableVariantID)
      .replaceAll("[[item_variant]]", firstAvailableVariant?.title ?? "")
      .replaceAll("[[item_variant_id]]", firstAvailableVariantID)
      .replaceAll("[[item_variant_title]]", firstAvailableVariant?.title ?? "")
      .replaceAll("[[item_product_id]]", productShopifyId)
      .replaceAll("[[item_product_title]]", title)
      .replaceAll("[[item_name]]", title)
      .replaceAll("[[discount]]", compareAtPrice ? Number((compareAtPrice - price).toFixed(2)) : 0)
      .replaceAll("[[price]]", price)
      .replaceAll("[[item_brand]]", author)
      .replaceAll("[[item_list_id]]", collectionId || null)
      .replaceAll("[[item_list_name]]", collection?.title ? `"${collection?.title}"` : null)
    ;

  const layoutMode =
    newLayoutMode == "list"
      ? "horizontal"
      : "vertical";

  const infoEl = [format, publisher, publicationDateStr]
  .filter(Boolean)
  .map(info => `<span>${info}</span>`)
  .join("<span class='jc-leading-4'>-</span>");

  const variantsJson = {
    variants: product.shopifyRespone?.variants.edges.map(item => item.node.id.split('/').pop()) || []
  };

  const productItemEl = productItemTemplate
    .replaceAll("[[!available]]", !available)
    .replaceAll("[[variantsJson]]", JSON.stringify(variantsJson).replace(/"/g, "&quot;"))
    .replaceAll("[[layoutMode]]", layoutMode)
    .replaceAll("[[firstAvailableVariantID]]", firstAvailableVariantID)
    .replaceAll("[[favouriteProductEl]]", favouriteProductEl)
    .replaceAll("[[productURL]]", productURL)
    .replaceAll("[[imgSrc]]", imgSrc)
    .replaceAll("[[title]]", title)
    .replaceAll("[[hideImage]]", hideImage)
    .replaceAll("[[!hideImage]]", !hideImage)
    .replaceAll("[[author]]", author)
    .replaceAll("[[infoEl]]", infoEl)
    .replaceAll("[[price]]", price ? window.jollyFunctions.formatMoney(price) : "")
    .replaceAll("[[compareAtPrice]]", compareAtPrice ? window.jollyFunctions.formatMoney(compareAtPrice) : "")
    .replaceAll("[[hideCompareAtPrice]]", compareAtPrice <= price)
    .replaceAll("[[hideSecondaryAtcButton]]", mainSearch)
    .replaceAll("[[L1_main_category]]", L1_main_category ? `&quot;${L1_main_category}&quot;` : null)
    .replaceAll("[[L2_main_category]]", L2_main_category ? `&quot;${L2_main_category}&quot;` : null)
    .replaceAll("[[pricing_group]]", pricing_group ? `&quot;${pricing_group}&quot;` : null)
    .replaceAll("[[pricing_stage]]", pricing_stage ? `&quot;${pricing_stage}&quot;` : null)
    .replaceAll("[[productShopifyId]]", productShopifyId)
  ;

  return productItemEl;
}

class SearchPagination extends HTMLElement {
  static observedAttributes = ["page"];

  constructor() {
    // Always call super first in constructor
    super();
  }

  connectedCallback() {
    this.innerHTML = document.getElementById( 
      "search-page-pagination"
    ).innerHTML;
  }

  updatePagination(data, currentPage, defaultProductsPerPage) {
    this.data = data;
    this.defaultProductsPerPage = defaultProductsPerPage;
    const resultsProductsCount = data;
    const countPagination = Math.ceil(
      resultsProductsCount / +defaultProductsPerPage
    );
    const nextPageButton = this.querySelector(".pagination__next");
    const prevPageButton = this.querySelector(".pagination__prev");
    const paginationCount = this.querySelector(".js-pagination__count-page");
    const paginationCurrentPage = this.querySelector(
      ".js-pagination__current-page"
    );

    prevPageButton?.setAttribute('aria-disabled', currentPage == 1);
    nextPageButton?.setAttribute('aria-disabled', currentPage == countPagination);

    if (paginationCount) {
      paginationCount.innerHTML = countPagination;
    }
    if (paginationCurrentPage) {
      paginationCurrentPage.innerHTML = currentPage;
    }

    nextPageButton?.setAttribute("data-page", currentPage + 1);
    prevPageButton?.setAttribute("data-page", currentPage - 1);

    if (countPagination == 1) {
      this.closest("[data-pagination]")?.classList.add("jc-hidden");
    } else {
      this.closest("[data-pagination]")?.classList.remove("jc-hidden");
    }

    this.querySelectorAll("[data-pagination-item]").forEach((el, index) => {
      el.classList.remove("is-active", "jc-pointer-event-none");
      if (el.classList.contains("js-first-page")) {
        el.innerHTML = 1;
        el.setAttribute("data-page", 1);
      } else if (el.classList.contains("js-last-page")) {
        el.innerHTML = countPagination;
        el.setAttribute("data-page", countPagination);
      } else {
        let pageShift = currentPage - 3;
        el.innerHTML = pageShift + index;
        el.setAttribute("data-page", pageShift + index);
        el.classList.remove("jc-hidden");
        if (pageShift + index < 2 || pageShift + index > countPagination - 1) {
          el.classList.add("jc-hidden");
        }
        if (pageShift <= 1) {
          this.querySelector(".js-first-spacing").classList.add("jc-hidden");
        } else {
          this.querySelector(".js-first-spacing").classList.remove("jc-hidden");
        }
        if (pageShift + 6 >= countPagination) {
          this.querySelector(".js-last-spacing").classList.add("jc-hidden");
        } else {
          this.querySelector(".js-last-spacing").classList.remove("jc-hidden");
        }
      }
    });

    this.querySelectorAll(
      `[data-page='${currentPage}']:not(.jc-hidden)`
    ).forEach((el) => {
      el.classList.add("is-active", "jc-pointer-event-none");
    });
  }

  attributeChangedCallback(name, oldValue, newValue) {
    this.updatePagination(this.data, newValue, this.defaultProductsPerPage);
  }
}

customElements.define("pagination-search", SearchPagination);
